import { Auth0Provider as AuthProvider } from "@auth0/auth0-react";
import { FC, ReactNode } from "react";
import { useHistory } from "react-router-dom";

import { appConfig } from "env-config";
interface Auth0ProviderProps {
  children: ReactNode;
}

export const Auth0Provider = ({ children }: Auth0ProviderProps) => {
  const navigate = useHistory();
  const domain = appConfig.REACT_APP_AUTH0_DOMAIN;
  const clientId = appConfig.REACT_APP_AUTH0_CLIENT_ID;
  const audience = appConfig.REACT_APP_AUTH0_AUDIENCE;
  const onRedirectCallback = (appState: any) => {
    window.history.replaceState(
      {},
      document.title,
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  };
  return (
    <AuthProvider
      domain={domain}
      clientId={clientId}
      audience={audience}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </AuthProvider>
  );
};
